import React from 'react'
import { ReactComponent as RocketLaunch } from '../../../Assets/img/Profile/ppfimage.svg';

const PPF = () => {
  return (
    <div className='finance-container m-5 d-flex flex-column justify-content-center align-items-center min-vh-50'>
      <div className="text-center mb-4">
        <RocketLaunch width={150} height={150} />
      </div>

      <p className='finance-txt text-center'>All Good Things Come to Those who Wait...</p>
      <p className='m-0 fs-5 text-center' style={{ color: "rgb(0, 0, 0, 0.6) " }}>Are you Ready to get something new from us.</p>
      <p className='text-center' style={{ color: "rgb(0, 0, 0, 0.6) " }}>Stay tuned for something amazing.</p>
    </div>
  )
}

export default PPF